'use strict';

class RcmFatResultsMap {
    constructor(fat) {
        this.fat = fat;

        // DOM
        this.map = $('#fatv2-results-map');
        this.feedbackEl = $('#fatv2-results-feedback');

        // Google parameters
        this.options = {
            zoom: 12,
            maxZoom: 14,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,   
        };

        // Google objects
        this.gMapGeocoder = null;
        this.gMap = null;
        this.gMapCenter = null;
        this.gMapZoom = null;
        this.gHomeMarker = null;
        this.gMarkers = [];
        this.gMarkersCluster = null;
        this.gBounds = null;
        this.hasMapEvents = false;
        this.showAreaSearchOnZoom = false;
    }

    // Set results (map)
    set(clear, onMapMove, onPageChange) {
        var self = this;

        // Show feedback if no results
        if (self.fat.resultsPaged[self.fat.mapCurrentPage].count === 0) {
            self.feedbackEl.removeClass('hide');
            self.map.addClass('hide');
        } else {
            self.feedbackEl.addClass('hide');
            self.map.removeClass('hide');
        }

        // preserve the current map zoom
        // and map center
        if (self.gMap) {
            self.gMapCenter = self.gMap.getCenter();
            self.options["zoom"] = self.gMap.getZoom();
            self.options["center"] = { lat: self.gMapCenter.lat(), lng: self.gMapCenter.lng() };
        }

        // (Re)start map
        if (clear) {
            self.gHomeMarker = '';
            self.gMapGeocoder = new google.maps.Geocoder();
            self.gMap = new google.maps.Map(self.map[0], self.options);
            self.gBounds = new google.maps.LatLngBounds(null);
        }

        // remove any markers currently on the page
        if (self.gMarkers.length > 0) {
            self.removeMapMarkers();
        }

        var placeId = self.fat.form.geoPlaceField.val();        

        // Get the geolocation from the placeId
        self.gMapGeocoder.geocode({ 'placeId': placeId }, function (results, status) {
            // If the Maps can't find the placeID (which seems impossible to me)
            if (status !== 'OK') {
                window.alert('Geocoder failed due to: ' + status);
                return;
            }

            // Add the "home" marker for the inital location search
            if (clear) {

                if (!self.gMapCenter) {
                    self.gMap.setCenter(results[0].geometry.location);
                }

                self.gHomeMarker = new google.maps.Marker({
                    position: results[0].geometry.location,
                    icon: '/RCM/assets/img/fat/v2/NTD_home.png'
                });

                self.gHomeMarker.setMap(self.gMap);
            }
            
            // create the current "page" of results' markers
            $.each(self.fat.resultsPaged[self.fat.mapCurrentPage].hits, function (uniqueId, value) {

                var gLatLng = new google.maps.LatLng(value.item._rankingInfo.matchedGeoLocation.lat, value.item._rankingInfo.matchedGeoLocation.lng);

                // extend the map bounds
                self.gBounds.extend(gLatLng);

                // if (self.gMap.getBounds().contains(gLatLng)) {

                // the marker may already be created
                // b/c of the pagination behaviour
                if (!value["marker"]) {

                    var _icon = value.item.isCertified ? `/RCM/assets/img/fat/v2/NTD_pin_certified.png?marker=1&uid=${uniqueId}` : `/RCM/assets/img/fat/v2/NTD_pin.png?marker=1&uid=${uniqueId}`;

                    // show only markers that will fit on the map
                    // Create a marker for a teacher
                    value["marker"] = new google.maps.Marker({
                        position: gLatLng,
                        title: `${value.item.fullName} (${uniqueId})`,
                        animation: google.maps.Animation.DROP,
                        icon: _icon, // This query string is important to be possible find the image later on DOM
                    });

                    // Add a listener to the marker click
                    value["marker"] = self.fat.events.onMapMarkerClick(value["marker"], uniqueId);
                }

            });

            // add the markers to the map
            self.addMapMarkers();


            if (clear || onPageChange) {
                // set this property to false
                // so that the search button does not appear
                self.showAreaSearchOnZoom = false;
                // Set map zoom based on markers
                self.gMap.fitBounds(self.gBounds);  
            }

        });

        if (self.gMap && clear) {
            // Add a listener to the map zoom
            //self.gMap = self.fat.events.onMapZoom(self.gMap);

            // Listener on map move
            self.gMap.addListener('dragend', function () {
                self.showSearchMapMoveCtrl();
            });

            self.gMap.addListener('zoom_changed', function () {
                // zoom_changed can be triggered by the fitBounds method on the map
                // so we must avoid showing the search area button in some cases
                if (self.showAreaSearchOnZoom) {
                    self.showSearchMapMoveCtrl();
                }

                self.showAreaSearchOnZoom = true;
                           
            });
        }
    }

    showSearchMapMoveCtrl() {
        var self = TPS.RcmFindTeacher.resultsMap;

        // add the button to the map
        var ctrl = document.getElementById('fatv2-researh-area');

        if (!ctrl) {
            ctrl = document.createElement('a');
            ctrl.id = 'fatv2-researh-area';
            ctrl.href = '#';
            ctrl.innerHTML = 'Search this area';
            ctrl.className = 'button tps-button-filled tps-button-dark-purple fatv2-results-map-search-area-ctrl';

            self.map.prepend(ctrl);

            // listen for the button to be clicked
            ctrl.addEventListener('click', function (e) {
                e.preventDefault();
                // research the current area
                self.fat.algolia.doSearchMapMove();
                ctrl.remove();
            });
        }

    }

    // Start highlight marker
    startHighlightMarker(uniqueId) {
        if (!this.gMarkersCluster) {
            return;
        }

        // Marker
        var target = $(`img[src$="marker=1&uid=${uniqueId}"]`);
        if (target.length > 0) {
            var target = target.parent();
            target.addClass('fatv2-marker fatv2-marker-animated');
        }

        // Cluster
        var clusters = this.gMarkersCluster.getClusters();
        var cluster = null;
        var marker = null;

        for (var i = 0, l = clusters.length; i < l; i++) {
            cluster = clusters[i];

            for (var j = 0, le = clusters[i].markers_.length; j < le; j++) {
                marker = clusters[i].markers_[j];

                if (marker.title.indexOf(`(${uniqueId})`) != -1) {
                    var target = $(cluster.clusterIcon_.div_);
                    target.addClass('fatv2-cluster fatv2-cluster-animated');
                }
            }
        }
    }

    // End highlight marker
    endHighlightMarker(uniqueId) {
        if (!this.gMarkersCluster) {
            return;
        }

        // Marker
        var target = $(`img[src$="marker=1&uid=${uniqueId}"]`);
        if (target.length > 0) {
            var target = target.parent();
            target.removeClass('fatv2-marker-animated');
        }

        // Cluster
        var clusters = this.gMarkersCluster.getClusters();
        var cluster = null;
        var marker = null;

        for (var i = 0, l = clusters.length; i < l; i++) {
            cluster = clusters[i];

            for (var j = 0, le = clusters[i].markers_.length; j < le; j++) {
                marker = clusters[i].markers_[j];

                if (marker.title.indexOf(`(${uniqueId})`) != -1) {
                    var target = $(cluster.clusterIcon_.div_);
                    target.removeClass('fatv2-cluster-animated');
                }
            }
        }
    }

    addMapMarkers() {

        var self = this;
        var items = self.fat.resultsPaged[self.fat.mapCurrentPage].hits;
        var pageMarkers = {};
        
        for (var hit in self.fat.resultsPaged[self.fat.mapCurrentPage].hits) {
            
            if(items[hit].marker) {
                // Add the marker to the map
                items[hit].marker.setMap(self.gMap);
                pageMarkers[hit] = items[hit].marker;
                self.gMarkers.push(items[hit].marker);
            }
        }

        // If there are clusters already active,
        // clear them to avoid have multiple identical clusters
        if (self.gMarkersCluster != null) {
            self.gMarkersCluster.clearMarkers();
        }

        // Add a marker clusterer to manage the markers
        self.gMarkersCluster = new MarkerClusterer(self.gMap, pageMarkers, {
            imagePath: '/RCM/assets/img/fat/v2/NTD_m'
        });


    }

    removeMapMarkers() {

        var self = this;
        self.gMarkers.forEach( (marker, index) => {
            marker.setMap(null);
            self.gMarkers.splice(index, 1);
        });

        // clear any clusters if they exist
        if (self.gMarkersCluster != null) {
            self.gMarkersCluster.clearMarkers();
            self.gMarkersCluster = null;
        }

    }

}
